import { Typography, Box, useTheme } from "@mui/material"
import { ReactElement } from "react"

import { SUPPORT_REFER } from "../../errors/errorMessages"

/**
 * Displays generic error message for data load failures (when `isError`)
 * is flagged by SWR
 */
const DataLoadError = (): ReactElement => {
    const theme = useTheme()
    return (
        <Typography variant="h6" component="div">
            Whoops!{" "}
            <Box color={theme.palette.primary.main} display="inline">
                Something went wrong 😞.
            </Box>{" "}
            Please try{" "}
            <Typography
                variant="h6"
                color="secondary"
                sx={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    display: "inline",
                }}
                onClick={() => window.location.reload()}
            >
                refreshing the webpage
            </Typography>
            . {SUPPORT_REFER}
        </Typography>
    )
}

export default DataLoadError
